import React, { useEffect, Fragment } from "react";
import { Header, CardList, SearchBox } from "../components";
import { Scrollbars as Scrollbar } from "react-custom-scrollbars";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { setSearchField, setRobotSetField } from "../store/search/actions";
import { requestRobots } from "../store/robot/actions";
import { IRootState } from "../store/store";
import { IRobot } from "../store/robot/types";
import { RobotSet } from "../store/search/types";
import _ from "lodash";
import RobotSetSelector from "../components/RobotSetSelector";
import "./App.css";

type AppState = {
  searchField: string;
  users: Array<IRobot>;
  set: RobotSet;
  isPending: boolean;
  error: string;
};

const App: React.FC = (): React.ReactElement => {
  const dispatch = useDispatch();
  const selector = (state: IRootState): AppState => ({
    searchField: state.search.searchField,
    users: state.robots.items,
    set: state.search.set,
    isPending: state.robots.isPending,
    error: state.robots.error,
  });
  const { searchField, users, set, isPending, error }: AppState = useSelector(
    selector,
    shallowEqual
  );

  useEffect((): void => {
    dispatch(requestRobots(9));
  }, [dispatch]);

  const getHeaderTitle: Function = (): string => {
    switch (set) {
      case "set2":
        return "Ogrebots";
      case "set3":
        return "Tinybots";
      case "set4":
        return "Kittybots";
      default:
        return "Robo Buddies";
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void =>
    dispatch(setSearchField(e.target.value));

  const handleSelectSetChange = (
    e: React.ChangeEvent<HTMLSelectElement>
  ): void => {
    dispatch(setRobotSetField(e.target.value as RobotSet));
  };

  const filteredUsers: Array<IRobot> = users.filter(
    ({ name }: IRobot): boolean =>
      name.toLowerCase().includes(searchField.toLowerCase())
  );

  const randomRobots: Array<IRobot> = _.shuffle(filteredUsers);

  return (
    <div className="tc">
      {error ? (
        <h1 className="dark-red">{error}</h1>
      ) : isPending ? (
        <h1>Loading robots...</h1>
      ) : !users.length ? (
        <h1>There is no robot.</h1>
      ) : (
        <Fragment>
          <Header title={getHeaderTitle()} />
          <div className="flex items-center justify-center">
            <SearchBox onSearchChange={handleSearchChange} />
            <RobotSetSelector onSetChange={handleSelectSetChange} />
          </div>
          <Scrollbar style={{ height: 800 }}>
            <CardList robots={randomRobots} />
          </Scrollbar>
        </Fragment>
      )}
    </div>
  );
};

export default App;
